import { getTimerTemplate, getVueTimer } from "../../shortcodes/templates";

let timer = null;
const visualizeTimer = content => {
  timer = content.querySelectorAll('[data-wrapper-id="timer"]');
  if (timer.length > 0) {
    timer.forEach(item => {
      const data = item.querySelector("timer")?.getAttribute("quantity");

      if (data) {
        item.innerHTML = getTimerTemplate(decodeURIComponent(data));
      }
    });
  }
};

const serializeTimer = content => {
  const timer = content.querySelectorAll('[data-wrapper-id="timer"]');
  if (timer.length > 0) {
    timer.forEach(item => {
      //Prevents from running serialization on timer shortcode multiple times when using multistep quiz
      if (!item.querySelector("timer")) {
        const data = item.querySelector(".timeout")?.innerHTML;

        if (data) {
          item.innerHTML = getVueTimer(encodeURIComponent(data));
        }
      }
    });
  }
};

export { visualizeTimer, serializeTimer };
